import { envConfig } from "@/config";

/**
 * Env-based feature gating by appliance ID.
 *
 * Allowlists are comma-separated appliance IDs in env:
 * - Empty = disabled everywhere
 * - "*" = enabled for all appliances
 * - otherwise enabled only when the current appliance ID is listed
 */
function isApplianceAllowlisted(rawAllowlist: string | undefined | null, applianceId: string | undefined | null): boolean {
	const raw = (rawAllowlist ?? "").trim();
	if (raw === "") return false;

	const ids = raw
		.split(",")
		.map((id) => id.trim())
		.filter(Boolean);

	if (ids.includes("*")) return true;
	return !!applianceId && ids.includes(applianceId);
}

/** AI Activity Overview — `VITE_AI_OVERVIEW_APPLIANCE_IDS`. */
export function isAiOverviewEnabled(applianceId: string | undefined | null): boolean {
	return isApplianceAllowlisted(envConfig.AI_OVERVIEW_APPLIANCE_IDS, applianceId);
}
